import { isValid } from 'date-fns'

export const getIsDateRangeFilterSelected = (filtersState, filter) => {
  return isValid(filtersState[filter.filterName]?.startDate) && isValid(filtersState[filter.filterName]?.endDate)
}
